import {
  noShowCancellationSummaryResponseSchema,
  type NoShowCancellationSummary,
  type NoShowCancellationSummaryQuery,
} from '@emr/shared';

import { apiRequest } from './client.ts';

/** `GET /api/appointments/reports/no-show-summary?providerId=&from=&to=` — counts, rates, and the
 * most recent cancelled/no-show appointments over a date range (`BACKLOG.md` K3). Reuses
 * `appointments.ts`'s own validated-schema convention. */
export async function getNoShowCancellationSummary(
  query: NoShowCancellationSummaryQuery,
  signal?: AbortSignal,
): Promise<NoShowCancellationSummary> {
  const params = new URLSearchParams({ from: query.from, to: query.to });
  if (query.providerId !== undefined) params.set('providerId', query.providerId);
  const response = await apiRequest(
    `/api/appointments/reports/no-show-summary?${params.toString()}`,
    noShowCancellationSummaryResponseSchema,
    signal === undefined ? {} : { signal },
  );
  return response.summary;
}
